import {FormInputType} from '../../../../blocks/FormBlock'
import {copy} from '../../../../../util/fieldscopy'

const questionsField: FormInputType = {
	id: 0,
	parent_id: 0,
	channel: 'input',
	type: 'textarea',
	label: copy?.questions || 'Heb je nog een vraag of opmerking?',
	name: 'questions',
	placeholder: '',
	required: false
}

export default questionsField
